module.exports = __webpack_public_path__ + "assets/img/heart.e7de8a2e.svg";